import { Container, Box, Typography, Button, Paper, Link as MuiLink, TextField } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import { useAppDispatch } from "../../../redux/features/redux-hooks";
import { register } from '../../../redux/features/Auth/AuthThunk';
import { toast } from '../../../components/common/SnackBar/snackBar';
import verifyOtpPageStyles from '../../../styles/PublicPage/verifyotppage';
import { sendOtpForSignup } from '../../../api/AuthAPI';
import { PATH_NAME } from '../../../configs/pathName';
import { typo } from '../../../assets/fonts/font';
import colorConfigs from '../../../configs/colorConfigs';
import assets from '../../../assets';

const VerifyOtpPage = () => {
    const { state } = useLocation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    
    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(true);
    const [countdownStarted, setCountdownStarted] = useState(false);

    useEffect(() => {
        if (countdownStarted && timer > 0) {
            const countdown = setTimeout(() => setTimer(timer - 1), 1000);
            return () => clearTimeout(countdown);
        } else if (timer === 0) {
            setCanResend(true);
            setCountdownStarted(false);
        }
    }, [timer, countdownStarted]);

    const handleVerifyOtp = async () => {
        if (otp) {
            try {
                const { country_code, mobile } = state;

                const data = {
                    country_code,
                    mobile,
                    password: state.password,
                    otp,
                    signup_source: "nommi",
                };

                await dispatch(register(data)).unwrap();
                navigate(PATH_NAME.INTRODUCTION);
            } catch (error) {
                toast.error("OTP verification failed.");
            }
        } else {
            toast.error("Please enter OTP.");
        }
    };

    const handleResendOtp = async () => {
        try {
            const { country_code, mobile } = state;
            const full_mobile = `${country_code}${mobile}`;
    
            await sendOtpForSignup(full_mobile);
            setTimer(30);
            setCanResend(false);
            setCountdownStarted(true);
            toast.success("OTP resent successfully!");
        } catch (error:any) {
            toast.error(error.message);
        }
    };
    
    const handleEditNumber = () => {
        navigate(PATH_NAME.REGISTER, {
            state: {
                country_code: state.country_code,
                mobile: state.mobile,
                password: state.password,
            }
        });
    };

    return (
        <Box component="section" sx={verifyOtpPageStyles.section}>
            <Container maxWidth="xs">
                <Paper elevation={0} sx={verifyOtpPageStyles.paper}>
                    <Box sx={verifyOtpPageStyles.logoContainer}>
                        <img
                            alt="Company Logo"
                            src={assets.images.logo}
                            style={verifyOtpPageStyles.logoImage}
                        />
                    </Box>
                    <Typography
                        variant="h5"
                        component="h1"
                        align="center"
                        gutterBottom
                        sx={{...verifyOtpPageStyles.title, ...typo.sectionHeadline}}
                    >
                        OTP Verification
                    </Typography>
                    <Typography
                        variant="body1"
                        align="center"
                        gutterBottom
                        sx={{...verifyOtpPageStyles.subtitle, ...typo.bodyContent}}
                    >
                        We will send you a <strong>One Time Password</strong> on your phone number {state.country_code + state.mobile}.&nbsp;
                        <MuiLink component="button" onClick={handleEditNumber} sx={{...typo.bodyContent}}>
                            Edit Number
                        </MuiLink>
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        inputProps={{
                            maxLength: 6,
                            inputMode: 'numeric',
                            pattern: '[0-9]*',
                            sx: {
                                ...typo.bodyContent,
                            },
                        }}
                        InputLabelProps={{
                            sx: {
                                ...typo.bodyContent,
                            },
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    ...typo.bodyContent,
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: colorConfigs.primary,
                                    ...typo.bodyContent,
                                },
                            },
                            "& .MuiInputLabel-root": {},
                            "& .MuiInputLabel-root.Mui-focused": {
                                ...typo.bodyContent,
                            },
                            mb: 2
                        }}
                        />
                        <Button
                            fullWidth
                            variant="contained"
                            sx={{...typo.button,...verifyOtpPageStyles.button}}
                            onClick={handleVerifyOtp}
                        >
                            Verify OTP
                        </Button>
                        <Typography align="center" sx={{...verifyOtpPageStyles.resendText, ...typo.bodyContent}}>
                            Didn’t receive the OTP?{' '}
                            {canResend ? (
                                <MuiLink component="button" onClick={handleResendOtp} sx={{...typo.bodyContent}}>
                                    Resend OTP
                                </MuiLink>
                            ) : (
                                <span>Resend OTP in {timer} seconds</span>
                            )}
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default VerifyOtpPage;